<template>

    <div>

        <v-hero :title="title" />

        <v-section-clients :headline="false" />
        <v-section-uses />
        <v-section-testimonials />
        <v-section-signoff title="Explore all our features risk-free for 14 days" />

    </div>

</template>

<style scoped lang="scss">

    .hero {
        text-align: left;
        h1 {
            text-align: left;
        }
        .ss {
            background: $color-text;
            border-radius: 5px;
            padding-top: 50%;
            width: 100%;
        }
    }

</style>

<script>

import Hero from './components/Hero';
import SectionUses from './components/SectionUses';

export default {

    components: {
        'v-hero': Hero,
        'v-section-uses': SectionUses,
    },

    computed: {

        title() {
            const name = this.$route.name;
            if (name === 'customer-engagement') {
                return 'Customer Engagement';
            } else if (name === 'customer-management') {
                return 'Customer Management';
            } else if (name === 'customer-segmenting') {
                return 'Customer Segmenting';
            } else if (name === 'email-builder') {
                return 'Email Builder';
            }
            return this.$route.meta.title;
        },

    },

}

</script>